<script>
import BaseInput from "./Base/BaseInput3";
import RadioInput from "@/components/Base/RadioInput.vue";
import Area2 from "./Area2";
import BaseLoader from "./Base/BaseLoader";
import BaseLocation from "./Base/BaseLocation3";
import BaseOneChoiseCheckbox from "./Base/BaseOneChoiseCheckbox";
import BasePdfUploader from "@/components/Base/BaseGeneralPdfUploader.vue";
import SaveInfo from "./Base/SaveInfo";
import axios from "axios";
import {FontAwesomeIcon} from '@fortawesome/vue-fontawesome';
import {library} from '@fortawesome/fontawesome-svg-core';
import {faEdit, faTrash} from '@fortawesome/free-solid-svg-icons';
import 'v-calendar/dist/style.css';
import moment from "moment"
import { Modal } from 'ant-design-vue'

library.add(faEdit);
library.add(faTrash);

export default {
	name: 'AreaQuizComponent',
	data() {
		return {
			area: {},
			areas2: [],
			areaid: 0,
			thisYearDate1: '2024-09-01',
			thisYearDate2: '2025-05-01',
			user: null,
			newPassword: "",
			test: '',
			translations: [],
			countriesinput: [],
			validationRules: [
				{
					fieldName: 'firm_name',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Наименование организации" обязательно для заполнения'
				},
				{
					fieldName: 'email',
					isRequired: true,
					entity: 'user',
					errorText: 'Поле "E-mail представителя площадки" обязательно для заполнения'
				},
				{
					fieldName: 'email',
					isEmail: true,
					entity: 'user',
					errorText: 'Поле "E-mail представителя площадки" должно быть в формате email адреса и латинскими буквами'
				},
				{
					fieldName: 'phone',
					isRequired: true,
					entity: 'user',
					errorText: 'Поле "Телефон представителя площадки" обязательно для заполнения'
				},
				{
					fieldName: 'lastname',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Фамилия представителя площадки" обязательно для заполнения'
				},
				{
					fieldName: 'firstname',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Имя представителя площадки" обязательно для заполнения'
				},
				{
					fieldName: 'dolzhnost',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Должность представителя площадки" обязательно для заполнения'
				},
				{
					fieldName: 'country',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Страна" обязательно для заполнения'
				},
				{
					fieldName: 'region',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Регион" обязательно для заполнения'
				},
				{
					fieldName: 'city',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Город" обязательно для заполнения'
				},
				{
					fieldName: 'poselok',
					isRequired: false,
					entity: 'area',
					errorText: 'Поле "Село" обязательно для заполнения'
				},
				// {
				//   fieldName: 'area_name',
				//   isRequired: true,
				//   entity: 'area',
				//   errorText: 'Поле "Название площадки" обязательно для заполнения'
				// },
				{
					fieldName: 'area_address',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Адрес площадки" обязательно для заполнения'
				},
				{
					fieldName: 'show_contact_info2024',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Согласие с политикой персональных данных" обязательно для заполнения'
				},
				{
					fieldName: 'oferta2024',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Согласие с офертой" обязательно для заполнения'
				},
				{
					fieldName: 'oferta_general2024',
					isRequired: true,
					entity: 'area',
					errorText: 'Поле "Согласие с пользовательским соглашением" обязательно для заполнения'
				},
			],
			competition_id: '',
			area2id: 0,
			datetime: new Date(),
			type_datetime: '',
			international: window.international,
			isShow: false,
			isLoading: true,
			isSubmitted: false,
			isDataUpdating: false,
			errors: [],
			lang: 'ru'
		}
	},
	components: {
		BaseInput,
		SaveInfo,
		BaseLoader,
		FontAwesomeIcon,
		BaseOneChoiseCheckbox,
		BasePdfUploader,
		BaseLocation,
		Area2,
		RadioInput
	},
	mounted: function () {
		if (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)) {
			alert("Эта страница может работать некорректно в браузере Safari. Рекомендуемые браузеры Яндекс.Браузер или Google Chrome.");
		}
		
		//window.area2_id
		if (window.area2_id && window.area2_id !== '0') {
			this.showModal(window.area2_id);
		}
		
		this.getData();
	},
	computed: {
		userid() {
			return window.userid;
		},
		isAdmin() {
			return window.currentUserRoles.includes('ROLE_ADMIN')
		},
		isAfterRegister() {
			return window.isAfterRegister;
		},
		allAccepted() {
			return this.area.show_contact_info2024 && this.area.oferta2024 && this.area.oferta_general2024
		},
		hasShowsThisYear() {
			let res = false;
			this.areas2.forEach((area) => {
				if (area && area.data && area.data.shows && area.data.shows.length > 0) {
					area.data.shows.forEach((show) => {
						const showDate = moment(show.date);
						const startDate = moment(this.thisYearDate1);
						const endDate = moment(this.thisYearDate2);
						
						if (showDate.isBetween(startDate, endDate, null, '[]')) {
							res = true;
						}
					});
				}
			})
			return res;
		},
		isAreasHasRussian() {
			let res = false;
			this.areas2.forEach((area) => {
				if (area && area.data && area.data.country === 'Российская Федерация') {
					res = true
				}
			})
			return res;
		},
		isAreasHasForeign() {
			let res = false;
			this.areas2.forEach((area) => {
				if (area && area.data && area.data.country !== 'Российская Федерация') {
					res = true
				}
			})
			return res;
		},
	},
	methods: {
		async getData() {
			if (window.userid != 0) {
				const areaResponse = await axios.get('/api/page_metas?pageid=area_quiz&meta_value=' + window.userid, {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					}
				});
				
				if (areaResponse.data[0] !== undefined) {
					this.areaid = areaResponse.data[0].id;
					for (var key in areaResponse.data[0]['json_value']) {
						this.area[key] = areaResponse.data[0]['json_value'][key];
					}
				} else {
					alert('Ошибка получения данных')
					return;
				}
				
				if (this.area.isSelo) {
					const indexSelo = this.validationRules.findIndex(object => {
						return object.fieldName === 'poselok';
					});
					this.validationRules[indexSelo].isRequired = true;
					
					const indexCity = this.validationRules.findIndex(object => {
						return object.fieldName === 'city';
					});
					this.validationRules[indexCity].isRequired = false;
				}
				
				const userResponse = await axios.get('/api/users/' + window.userid, {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					}
				});
				this.user = userResponse.data;
				
				if (this.countriesinput.length === 0) {
					await this.loadCountries();
				}
				
				//Загружаем площадки 2 уровня
				//'/api/area2levels?area.id=' + window.userid
				const area2Response = await axios.get('/get_areas2levels/' + window.userid, {
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/json'
					}
				});
				this.areas2 = area2Response.data;
				
				this.lang = window.lang;
				this.competition_id = window.competition_id;
				this.translations = JSON.parse(window.translations);
				this.isLoading = false;
				this.isDataUpdating = false;
			} else {
				this.user = {
					'email': '',
					'password': '',
					'phone': ''
				};
				
				this.area = {
					'lastname': '',
					'firstname': '',
					'surname': '',
					'dolzhnost': '',
					'country': '',
					'region': '',
					'city': '',
					'selo': '',
					'soglashenie2024': '',
					'isSelo': false,
					// 'area_name': '',
					'area_address': '',
					'site': '',
					'show_contact_info2024': false,
					'oferta_general2024': false,
					'oferta2024': false,
					'firm_name': ''
				};
				
				this.validationRules.push(
					{
						fieldName: 'password',
						isRequired: true,
						entity: 'user',
						errorText: 'Поле "Пароль" обязательно для заполнения'
					},
				);
				
				if (this.countriesinput.length === 0) {
					await this.loadCountries();
				}
				this.isLoading = false;
			}
			window.area_country = this.area.country ?? '';
		},
		patchData() {
			this.isDataUpdating = true;
			axios.patch('/api/page_metas/' + this.areaid,
				{
					'jsonValue': this.area
				},
				{
					headers: {
						'Accept': 'application/json',
						'Content-Type': 'application/merge-patch+json',
					}
				}
			).then(() => {
				this.getData();
			}).catch(error => {
				console.log(error);
				alert('Ошибка получения данных')
			});
		},
		saveData() {
			const self = this;
			
			this.errors = [];
			if (window.userid != 0) {
				this.validationRules.forEach(function (field) {
					self.validateField(field)
				});
			}
			
			
			if (this.areaid !== 0 && window.userid != 0 && this.errors.length === 0) {
				this.patchData()
			} else {
				if (this.isSubmitted) {
					this.checkErrors(false);
				}
			}
		},
		saveUserData() {
			if (window.userid != 0) {
				this.isDataUpdating = true;
				axios.patch('/api/users/' + this.user.id,
					this.user,
					{
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/merge-patch+json',
						}
					}
				).then(() => {
					this.getData();
				});
			} else {
				if (this.isSubmitted) {
					this.checkErrors(false);
				}
			}
		},
		getYear(date) {
			return moment(date).format('YYYY');
		},
		isFieldRequired(fieldName) {
			let res = false;
			this.validationRules.forEach(function (field) {
				if (
					(field.fieldName === fieldName || field?.altFieldName === fieldName)
					&& field.isRequired) {
					res = true;
				}
			});
			return res;
		},
		validateField(field) {
			const self = this;
			if (field.isEmail && !this.validateEmail(self[field.entity][field.fieldName])) {
				if (!self.errors.find(x => x.text === field.errorText)) {
					self.errors.push({
						text: field.errorText,
						order: field.order ? field.order : '1'
					});
				}
			}
			if (
				field.isRequired && (self[field.entity][field.fieldName] === null || self[field.entity][field.fieldName]?.length === 0 || self[field.entity][field.fieldName] === false || self[field.entity][field.fieldName] === 0)) {
				if (!self.errors.find(x => x.text === field.errorText)) {
					self.errors.push({
						text: field.errorText,
						order: field.order ? field.order : '1'
					});
				}
			}
		},
		checkErrors(withScroll = true) {
			const self = this;
			self.errors = [];
			this.validationRules.forEach(function (field) {
				self.validateField(field)
			});
			if (this.errors.length > 0) {
				if (withScroll) {
					document.getElementById("main_block").scrollIntoView();
				}
			} else {
				if (window.userid == 0) {
					axios.post('/area/register', null, {
						params: {
							email: this.user.email,
							password: this.user.password,
							phone: this.user.phone,
							competition_id: window.competition_id,
							area: this.area
						}
					}).then((response) => {
						if (response.data === 'Анкета этого пользователя уже добавлена. Войдите в его аккаунт и обновите ее.') {
							alert('Анкета этого пользователя уже добавлена. Войдите в его аккаунт и обновите ее.');
						} else {
							if (window.is_coordinator) {
								alert('Площадка успешно добавлена');
								window.location.replace("/area_coordinator_table2");
							} else {
								location.reload();
							}
						}
					}).catch(error => {
						alert('Ошибка получения данных');
						console.log(error.response.data);
					})
				}
				
			}
		},
		showModal(areaId = 0) {
			if (areaId !== 0) {
				window.area2id = areaId;
			} else {
				window.area2id = false;
			}
			this.isShow = true;
		},
		closeModal() {
			this.isShow = false;
		},
		getTranslation(phrase) {
			let res;
			if (this.lang === 'en') {
				res = this.translations[phrase];
			} else {
				res = phrase;
			}
			return res;
		},
		async loadCountries() {
			const self = this;
			await axios.get('/get_all_countries', {
				headers: {
					'Accept': 'application/json',
				}
			})
				.then(response => {
					self.countriesinput = response.data;
				})
				.catch(error => {
					console.log(error);
				});
		},
		saveNewPassword() {
			let self = this;
			window.$.ajax({
				dataType: "json",
				type: 'post',
				data: {
					plainPassword: this.newPassword
				},
				url: '/change_profile_password',
				success: function () {
					self.newPassword = '';
					alert('Сохранено');
				},
				error: function (data) {
					alert('Ошибка получения данных' + data);
				}
			});
		},
		loadCities() {
			const self = this;
			const current_country = self.countriesinput.filter(function (el) {
				return el["ru_name"] === self.project.country;
			})
			if (current_country[0] && current_country[0].number) {
				axios.get('/get_world_cities/' + current_country[0].number, {
					headers: {
						'Accept': 'application/json',
					}
				}).then((response) => {
					self.citiestoinput = response.data;
				}).catch(error => {
					console.log(error);
				});
			}
		},
		validateEmail(email) {
			// eslint-disable-next-line no-useless-escape
			const re = /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
			return re.test(String(email).toLowerCase());
		},
		async checkBoxChecked() {
			if (this.area.show_contact_info2024 && this.area.oferta2024 && this.area.oferta_general2024) {
				this.areas2.forEach((area) => {
					axios.patch('/api/area2levels/' + area.id,
						{
							status: ''
						},
						{
							headers: {
								'Content-Type': 'application/merge-patch+json'
							}
						}
					);
				})
			}
		},
		// async deleteArea2(areaId) {
		// 	await axios.delete('/api/area2levels/' + areaId, {
		// 		headers: {
		// 			'Accept': 'application/json',
		// 			'Content-Type': 'application/json'
		// 		}
		// 	});
		// 	this.getData();
		// },
		async deleteArea2(areaId) {
			const area2 = await axios.get('/api/area2levels/' + areaId)
			console.log(area2.data?.data?.shows);
			if (area2.data?.data?.shows && area2.data?.data?.shows.length > 0) {
				alert('Площадка не может быть удалена, так как у нее есть показы');
			} else {
				if (confirm('Вы действительно хотите удалить площадку?')) {
					axios.delete('/api/area2levels/' + areaId, {
						headers: {
							'Accept': 'application/json',
							'Content-Type': 'application/json'
						}
					}).then(() => {
						this.getData();
					});
				}
			}
			
		},
		isAreasHasShowWithName(name) {
			let res = false;
			this.areas2.forEach((area) => {
				if (area && area.data && area.data.shows) {
					area.data.shows.forEach((show) => {
						if (show.show_programm == name) {
							res = true;
						}
					});
				}
			})
			return res;
		},
		
	},
	
}
</script>

<template>
	<div>
		<SaveInfo
			:isDataUpdating="isDataUpdating"
		></SaveInfo>
		<div id="main_block" v-if="!isLoading">
			<p class="step_text">Шаг 1</p>
			
			<div class="notification" v-if="isAfterRegister === '1'">
				<p>Поздравляем! Регистрация прошла успешно.</p>
				<p>ОСТАЛСЯ ПОСЛЕДНИЙ ШАГ</p>
				
				<p>Теперь вы можете заполнить информацию о площадке или нескольких площадках, на которых вы планируете
					провести показы. (под площадкой следует понимать не название организации-участника, а место
					проведения показа: кинотеатр, кинозал, музей, библиотека, арт-пространство, дом культуры, дом кино,
					киноклуб, лофт, точка кипения, мультимедийный центр, клуб, коворкинг, конференц-зал, дом народного
					творчества и др.)</p>
				
				<p v-if="userid != 0"><a class="button3" @click="showModal()"
				                         style="text-decoration: none; background: #F69F22;     border-color: #F69F22; font-size: 18px; color: #fff">Добавить
					площадку</a></p>
			</div>
			
			<div class="errors-block" v-if="errors.length">
				<b>Пожалуйста, заполните поля:</b>
				<ul>
					<li v-for="(error,index) in errors" :key="index" v-html="error.text"></li>
				</ul>
			</div>
			<div class="columns">
				<div class="column">
					
					<BaseInput
						:label="getTranslation('Наименование организации (юридическая организация, которая проводит показы фестиваля)')"
						v-model="area.firm_name"
						objectKey="firm_name"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
					
					<BaseInput
						:label="getTranslation('E-mail представителя организации')"
						:description="getTranslation('Будет вашим логином на платформе. По этому логину вы сможете войти в свой личный кабинет, который потребуется для дальнейшего общения с организаторами')"
						v-model="user.email"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						type="email"
						objectKey="email"
						@onChange="saveUserData"
					></BaseInput>
					
					<BaseInput
						v-if="userid === '0'"
						:label="getTranslation('Пароль')"
						description="Придумайте пароль для входа в личный кабинет."
						v-model="user.password"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						objectKey="phone"
						@onChange="saveUserData"
					></BaseInput>
					
					<BaseInput
						:label="getTranslation('Телефон представителя организации')"
						v-model="user.phone"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						objectKey="phone"
						@onChange="saveUserData"
					></BaseInput>
					
					<BaseInput
						:label="getTranslation('Фамилия представителя организации')"
						v-model="area.lastname"
						objectKey="lastname"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
					
					<BaseInput
						:label="getTranslation('Имя представителя организации')"
						v-model="area.firstname"
						objectKey="firstname"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
					
					<BaseInput
						:label="getTranslation('Отчество представителя организации')"
						v-model="area.surname"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
				</div>
				<div class="column">
					<BaseInput
						:label="getTranslation('Должность представителя организации')"
						v-model="area.dolzhnost"
						objectKey="dolzhnost"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
					
					<BaseLocation
						v-if="countriesinput.length > 0"
						parentObj="area"
						:countriesinput="countriesinput"
						:isDataUpdating="isDataUpdating"
						v-model:isSelo="area.isSelo"
						v-model:country="area.country"
						v-model:city="area.city"
						v-model:poselok="area.poselok"
						v-model:region="area.region"
						countryKey="country"
						regionKey="region"
						:isSeloLabelId="'selo1'"
						cityKey="city"
						labelCountry="Страна представителя организации"
						labelCity="Город представителя организации"
						labelRegion="Регион представителя организации"
						labelSelo="Село представителя организации"
						:isSubmitted="isSubmitted"
					></BaseLocation>
					
					
					<BaseInput
						:label="getTranslation('Адрес организации')"
						description="(улица, строение, корпус)"
						v-model="area.area_address"
						objectKey="area_address"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
					
					<BaseInput
						:label="getTranslation('Сайт')"
						:description="getTranslation('Указать адрес сайта при наличии')"
						v-model="area.site"
						:isDataUpdated="isDataUpdating"
						:isFormSubmitted="isSubmitted"
						@onChange="saveData"
					></BaseInput>
					
					<div class="field" v-if="userid != 0">
						
						<label for="user_edit_plainPassword">Пароль (оставьте пустым, если не требуется
							изменение)</label>
						<input type="text" id="user_edit_plainPassword" name="user_edit[plainPassword]"
						       v-model="newPassword">
						
						<button style="margin-top: 15px;" class="button2" @click.prevent="saveNewPassword">Сохранить пароль</button>
					</div>
				
				</div>
			</div>
			<div class="field">
				<BaseOneChoiseCheckbox
					label='Площадка подтверждает согласие с <a href="https://script.moviestart.ru/uploads/pdf/reglament_dkk_2024.pdf" target="blank">Регламентом</a> Всероссийской акции "День короткометражного кино-2024" и обработкой персональных данных'
					v-model="area.show_contact_info2024"
					fieldId="user_area_show_contact_info"
					objectKey="show_contact_info"
					:disabled="userid != 0 && area.show_contact_info2024 ? true : false"
					:checked="userid != 0 && area.show_contact_info2024 || userid === 0 && area.show_contact_info2024 ? true : false"
					@onChange="saveData(); checkBoxChecked()"
				></BaseOneChoiseCheckbox>
			</div>
			<div class="field">
				<BaseOneChoiseCheckbox
					label='С <a target="_blank" href="https://disk.yandex.ru/i/ZVvIREeGfdyQOA">Офертой</a> ознакомлен'
					v-model="area.oferta2024"
					fieldId="user_area_oferta"
					objectKey="oferta"
					@onChange="saveData(); checkBoxChecked()"
					:disabled="userid != 0 && area.oferta2024 ? true : false"
					:checked="userid != 0 && area.oferta2024  || userid === 0 && area.oferta2024 ? true : false"
				></BaseOneChoiseCheckbox>
			</div>
			<div class="field">
				<BaseOneChoiseCheckbox
					label='Я подтверждаю, что ознакомлен и принимаю <a href="/license" target="_blank">пользовательское соглашение</a> и <a href="/policy" target="_blank">условия конфиденциальности</a>'
					v-model="area.oferta_general2024"
					fieldId="oferta_general"
					objectKey="oferta_general"
					@onChange="saveData(); checkBoxChecked()"
					:disabled="userid != 0 && area.oferta_general2024 ? true : false"
					:checked="userid != 0 && area.oferta_general2024 || userid === 0 && area.oferta_general2024 ? true : false"
				></BaseOneChoiseCheckbox>
			</div>
			
			<!--            <BasePdfUploader-->
			<!--                    label="Загрузите подписанное соглашение для площадок (<a href='https://disk.yandex.ru/i/jnI7TM5TufVAUQ' target='_blank'>скачать</a>)"-->
			<!--                    object-key="kinoreserv"-->
			<!--                    v-model="area.soglashenie2024"-->
			<!--										:is-new-link="true"-->
			<!--                    @onChange="patchData"-->
			<!--                    is-required="true"-->
			<!--            ></BasePdfUploader>-->
			
			<p v-if="userid == 0">
				<button @click="checkErrors(); isSubmitted = true;" class="button2">Сохранить изменения</button>
			</p>
<!--			Было soglashenie2024 -->
			<div v-if="userid != 0 && area.oferta_general2024"
			     style="display: flex; flex-wrap: wrap; margin-top: 50px; align-items: end">
				
				
				<a class="mini_button" href="https://www.shortfilmdays.ru/raspisanie_2024" target="_blank">расписание</a>
				<div style="display: flex; flex-direction: column; justify-content: center">
					<!--          <img src="/images/SFD_logo_white_S_bla.png" style="width: 100px; margin-bottom: 15px; margin-left: auto; margin-right: auto;">-->
					<a class="mini_button" href="https://disk.yandex.ru/d/jmKvK7bM83UOWA" target="_blank">
						скачать логотип
					</a>
				</div>
				<a class="mini_button" href="https://disk.yandex.ru/d/y350OAzips2A6w" target="_blank">скачать релиз</a>
				<a class="mini_button" href="https://disk.yandex.ru/i/AzZjO951O3oTiQ" target="_blank">трейлер</a>
				<a class="mini_button" href="https://disk.yandex.ru/d/AIG3Vro12_hKAg" target="_blank">афиши</a>
				<a class="mini_button" href="https://www.shortfilmdays.ru/eho_festivalya_2024" target="_blank">описание программ</a>
				
<!--				<div style="display: flex; flex-wrap: wrap; margin-top: 50px; align-items: end;">-->
<!--					<template v-if="isAreasHasForeign">-->
<!--						<template v-if="isAreasHasShowWithName('«TENDER AGE» PROGRAMME')"><a class="mini_button"-->
<!--						                                                                     href="https://disk.yandex.ru/d/KgLiP8xiwVA4GA/TENDER%20AGE%2020mbps.mp4"-->
<!--						                                                                     target="_blank">«TENDER AGE» PROGRAMME-->
<!--							- Высокое качество</a><a class="mini_button"-->
<!--						                           href="https://disk.yandex.ru/d/fLUYLOy4QVKcJA/TENDER%20AGE%205mbps.mp4"-->
<!--						                           target="_blank">«TENDER AGE» PROGRAMME - Быстрое скачивание</a></template>-->
<!--						<template v-if="isAreasHasShowWithName('«MIRACLE IS ALWAYS NEARBY» PROGRAMME')"><a class="mini_button"-->
<!--						                                                                                   href="https://disk.yandex.ru/d/KgLiP8xiwVA4GA/A%20MIRACLE%20IS%20ALWAYS%20NEAR%2020mbps.mp4"-->
<!--						                                                                                   target="_blank">«MIRACLE-->
<!--							IS ALWAYS NEARBY» PROGRAMME - Высокое качество</a><a class="mini_button"-->
<!--						                                                       href="https://disk.yandex.ru/d/fLUYLOy4QVKcJA/A%20MIRACLE%20IS%20ALWAYS%20NEAR%205mbps.mp4"-->
<!--						                                                       target="_blank">«MIRACLE IS ALWAYS NEARBY» PROGRAMME-->
<!--							- Быстрое скачивание</a></template>-->
<!--						<template-->
<!--							v-if="isAreasHasShowWithName('FESTIVAL HITS. Regional Cinematography Support Fund PROGRAMME')"><a-->
<!--							class="mini_button" href="https://disk.yandex.ru/d/KgLiP8xiwVA4GA/FESTAVAL%20HITS.%20RCSF%2020mbps.mp4"-->
<!--							target="_blank">FESTIVAL HITS. Regional Cinematography Support Fund PROGRAMME - Высокое качество</a><a-->
<!--							class="mini_button" href="https://disk.yandex.ru/d/fLUYLOy4QVKcJA/FESTAVAL%20HITS.%20RCSF%205mbps.mp4"-->
<!--							target="_blank">FESTIVAL HITS. Regional Cinematography Support Fund PROGRAMME - Быстрое скачивание</a>-->
<!--						</template>-->
<!--						<template-->
<!--							v-if="isAreasHasShowWithName('MUSIC WORKSHOP. Regional Cinematography Support Fund PROGRAMME (DOCUMENTARY)')">-->
<!--							<a class="mini_button"-->
<!--							   href="https://disk.yandex.ru/d/KgLiP8xiwVA4GA/MUSICAL%20WORKSHOP.%20RCSF%2020mbps.mp4" target="_blank">MUSIC-->
<!--								WORKSHOP. Regional Cinematography Support Fund PROGRAMME (DOCUMENTARY) - Высокое качество</a><a-->
<!--							class="mini_button" href="https://disk.yandex.ru/d/fLUYLOy4QVKcJA/MUSICAL%20WORKSHOP.%20RCSF%205mbps.mp4"-->
<!--							target="_blank">MUSIC WORKSHOP. Regional Cinematography Support Fund PROGRAMME (DOCUMENTARY) - Быстрое-->
<!--							скачивание</a></template>-->
<!--						<template-->
<!--							v-if="isAreasHasShowWithName('FRAGILE SHOULDERS. Regional Cinematography Support Fund PROGRAMME (DOCUMENTARY)')">-->
<!--							<a class="mini_button"-->
<!--							   href="https://disk.yandex.ru/d/KgLiP8xiwVA4GA/FRAGILE%20SHOULDERS.%20RCSF%2020mbps.mp4"-->
<!--							   target="_blank">FRAGILE SHOULDERS. Regional Cinematography Support Fund PROGRAMME (DOCUMENTARY) - -->
<!--								Высокое качество</a><a class="mini_button"-->
<!--							                         href="https://disk.yandex.ru/d/fLUYLOy4QVKcJA/FRAGILE%20SHOULDERS.%20RCSF%205mbps.mp4"-->
<!--							                         target="_blank">FRAGILE SHOULDERS. Regional Cinematography Support Fund PROGRAMME-->
<!--							(DOCUMENTARY) - Быстрое скачивание</a></template>-->
<!--					</template>-->
<!--					<template v-if="isAreasHasRussian">-->
<!--						<template-->
<!--							v-if="isAreasHasShowWithName('ФЕСТИВАЛЬНЫЕ ХИТЫ. Программа Фонда поддержки регионального кинематографа (документальное кино)')">-->
<!--							<a class="mini_button"-->
<!--							   href="https://disk.yandex.ru/d/VmzUMt6OsHaABQ/ФЕСТИВАЛЬНЫЕ%20ХИТЫ.%20ФПРК%2020mbps.mp4"-->
<!--							   target="_blank">ФЕСТИВАЛЬНЫЕ ХИТЫ. Программа Фонда поддержки регионального кинематографа-->
<!--								(документальное кино) - Высокое качество</a>-->
<!--							<a class="mini_button"-->
<!--							   href="https://disk.yandex.ru/d/133576UD2WfvKQ/ФЕСТИВАЛЬНЫЕ%20ХИТЫ.%20ФПРК%205mbps.mp4" target="_blank">ФЕСТИВАЛЬНЫЕ-->
<!--								ХИТЫ. Программа Фонда поддержки регионального кинематографа (документальное кино) - Быстрое-->
<!--								скачивание</a>-->
<!--						</template>-->
<!--						<template v-if="isAreasHasShowWithName('SHORT FILM DAYS 2018-2022. ХИТЫ (игровое кино)')"><a-->
<!--							class="mini_button"-->
<!--							href="https://disk.yandex.ru/d/VmzUMt6OsHaABQ/SHORT%20FILM%20DAYS%202018-2022.%20ХИТЫ%2020mbps.mp4"-->
<!--							target="_blank">SHORT FILM DAYS 2018-2022. ХИТЫ (игровое кино) - Высокое качество</a>-->
<!--							<a class="mini_button"-->
<!--							   href="https://disk.yandex.ru/d/133576UD2WfvKQ/SHORT%20FILM%20DAYS%202018-2022.%20ХИТЫ%205mbps.mp4"-->
<!--							   target="_blank">SHORT FILM DAYS 2018-2022. ХИТЫ (игровое кино) - Быстрое скачивание</a>-->
<!--						</template>-->
<!--						<template-->
<!--							v-if="isAreasHasShowWithName('Конкурсная программа SHORT FILM DAYS. Жизнь как чудо (игровое и анимационное кино)')">-->
<!--							<a class="mini_button" href="https://disk.yandex.ru/i/r86PxiO_-6oJCQ" target="_blank">Конкурсная программа-->
<!--								SHORT FILM DAYS. Жизнь как чудо (игровое и анимационное кино) - Высокое качество</a>-->
<!--							<a class="mini_button" href="https://disk.yandex.ru/i/HPk0G2uShm2NDw" target="_blank">Конкурсная программа-->
<!--								SHORT FILM DAYS. Жизнь как чудо (игровое и анимационное кино) - Быстрое скачивание</a>-->
<!--						</template>-->
<!--						<template-->
<!--							v-if="isAreasHasShowWithName('МУЗЫКАЛЬНАЯ МАСТЕРСКАЯ. Программа Фонда поддержки регионального кинематографа (документальное кино)')">-->
<!--							<a class="mini_button"-->
<!--							   href="https://disk.yandex.ru/d/VmzUMt6OsHaABQ/МУЗЫКАЛЬНАЯ%20МАСТЕРСКАЯ.%20ФПРК%2020mbps.mp4"-->
<!--							   target="_blank">МУЗЫКАЛЬНАЯ МАСТЕРСКАЯ. Программа Фонда поддержки регионального кинематографа-->
<!--								(документальное кино) - Высокое качество</a><a class="mini_button"-->
<!--							                                                 href="https://disk.yandex.ru/d/133576UD2WfvKQ/МУЗЫКАЛЬНАЯ%20МАСТЕРСКАЯ.%20ФПРК%205mbps.mp4"-->
<!--							                                                 target="_blank">МУЗЫКАЛЬНАЯ МАСТЕРСКАЯ. Программа Фонда-->
<!--							поддержки регионального кинематографа (документальное кино) - Быстрое скачивание</a></template>-->
<!--						<template-->
<!--							v-if="isAreasHasShowWithName('ХРУПКИЕ ПЛЕЧИ. Программа Фонда поддержки регионального кинематографа (документальное кино)')">-->
<!--							<a class="mini_button" href="https://disk.yandex.ru/d/VmzUMt6OsHaABQ/ХРУПКИЕ%20ПЛЕЧИ.%20ФПРК%2020mbps.mp4"-->
<!--							   target="_blank">ХРУПКИЕ ПЛЕЧИ. Программа Фонда поддержки регионального кинематографа (документальное-->
<!--								кино) - Высокое качество</a><a class="mini_button"-->
<!--							                                 href="https://disk.yandex.ru/d/133576UD2WfvKQ/ХРУПКИЕ%20ПЛЕЧИ.%20ФПРК%205mbps.mp4"-->
<!--							                                 target="_blank">ХРУПКИЕ ПЛЕЧИ. Программа Фонда поддержки регионального-->
<!--							кинематографа (документальное кино) - Быстрое скачивание</a></template>-->
<!--						<template v-if="isAreasHasShowWithName('СУЗДАЛЬФЕСТ 6+ (анимационное кино)')"><a class="mini_button"-->
<!--						                                                                                 href="https://disk.yandex.ru/d/VmzUMt6OsHaABQ/Суздаль%206%2B%2015mbps.mp4"-->
<!--						                                                                                 target="_blank">СУЗДАЛЬФЕСТ-->
<!--							6+ (анимационное кино) - Высокое качество</a><a class="mini_button"-->
<!--						                                                  href="https://disk.yandex.ru/d/133576UD2WfvKQ/Суздаль%206%2B%205mbps.mp4"-->
<!--						                                                  target="_blank">СУЗДАЛЬФЕСТ 6+ (анимационное кино) - -->
<!--							Быстрое скачивание</a></template>-->
<!--						<template v-if="isAreasHasShowWithName('СУЗДАЛЬФЕСТ 12+ (анимационное кино)')"><a class="mini_button"-->
<!--						                                                                                  href="https://disk.yandex.ru/d/VmzUMt6OsHaABQ/Суздаль%2012%2B%2015mbps.mp4"-->
<!--						                                                                                  target="_blank">СУЗДАЛЬФЕСТ-->
<!--							12+ (анимационное кино) - Высокое качество</a><a class="mini_button"-->
<!--						                                                   href="https://disk.yandex.ru/d/133576UD2WfvKQ/Суздаль%2012%2B%205mbps.mp4"-->
<!--						                                                   target="_blank">СУЗДАЛЬФЕСТ 12+ (анимационное кино) - -->
<!--							Быстрое скачивание</a></template>-->
<!--						-->
<!--						<template v-if="isAreasHasShowWithName('Программа для Россотрудничества «Нежный возраст»')"><a-->
<!--							class="mini_button" href="https://disk.yandex.ru/d/133576UD2WfvKQ" target="_blank">Программа для-->
<!--							Россотрудничества «Нежный возраст»</a></template>-->
<!--						<template v-if="isAreasHasShowWithName('Программа для Россотрудничества «Чудо всегда рядом»')"><a-->
<!--							class="mini_button" href="https://disk.yandex.ru/d/133576UD2WfvKQ" target="_blank">Программа для-->
<!--							Россотрудничества «Чудо всегда рядом»</a></template>-->
<!--					-->
<!--					</template>-->
<!--				</div>-->
				
				<!--        {{ area.country }} && userid !== '6959'  && userid !== '7194'  -->
				<!--                <template v-if="area.country === 'Российская Федерация'">-->
				<!--                    <a class="mini_button" href="https://disk.yandex.ru/d/VmzUMt6OsHaABQ" target="_blank">программа эха (высокое качество)</a>-->
				<!--                    <a class="mini_button" href="https://disk.yandex.ru/d/133576UD2WfvKQ" target="_blank">программа эха (быстрое скачивание)</a>-->
				<!--                    &lt;!&ndash;          <a class="mini_button" href="https://www.shortday.ru/eho_festivalya" target="_blank">описание программ</a>&ndash;&gt;-->
				<!--                </template>-->
				<!--                <template v-else>-->
				<!--                    <a class="mini_button" href="https://disk.yandex.ru/d/KgLiP8xiwVA4GA" target="_blank">программа эха (высокое качество)</a>-->
				<!--                    <a class="mini_button" href="https://disk.yandex.ru/d/fLUYLOy4QVKcJA" target="_blank">программа эха (быстрое скачивание)</a>-->
				<!--                    &lt;!&ndash;                    <a class="mini_button" href="https://www.shortday.ru/filmi_dlya_zarubezhnih_ploshadok_2022"&ndash;&gt;-->
				<!--                    &lt;!&ndash;                       target="_blank">описание программ</a>&ndash;&gt;-->
				<!--                </template>-->
				
				<!--        Россотрудничество e.hagba@rs.gov.ru -->
				<!--        <template v-if="area.country === 'Российская Федерация' && userid !== '6959' && userid !== '7194'">-->
				<!--          <a class="mini_button" href="https://disk.yandex.ru/d/sJJSRcj1-_yOLg" target="_blank">кадры "Эхо" ДКК</a>-->
				<!--        </template>-->
				<!--        <template v-if="userid === '7194'">-->
				<!--          <a class="mini_button" href="https://disk.yandex.ru/d/qxn0WVGMaWogRA" target="_blank">кадры</a>-->
				<!--        </template>-->
				
				<!--        <a class="mini_button" href="https://disk.yandex.ru/d/DHc90Be5NSsGhA" target="_blank">скачать афиши "Эхо"</a>-->
			</div>
			
			<template v-if="userid != 0">
				<p class="step_text" style="padding-left: 0; margin-top: 50px; margin-bottom: 15px;">Шаг 2</p>
				<p><a class="button2" @click="showModal()">Добавить площадку</a></p>
				<h2>Список площадок</h2>
				<div style="margin-bottom: 10px;" v-for="item in areas2" :key="item.id">
					<p :data-areaId="item.id"><span style="margin-right: 30px;">{{ item.data.area_name }}</span>
						<a @click="showModal(item.id)">
							<FontAwesomeIcon style="margin-right: 20px;" icon="edit"></FontAwesomeIcon>
						</a>
						<template v-if="isAdmin">
							<a @click="deleteArea2(item.id)">
								<FontAwesomeIcon icon="trash"></FontAwesomeIcon>
							</a>
						</template>
					</p>
				</div>
			</template>
			
			<div>
				<template v-if="!allAccepted || this.areas2.length === 0">
					<div style="padding:15px; border: 1px solid #999;">
						<p style="color: red"><strong>Заявка НЕ подана. Чтобы отправить заявку:</strong></p>
						<ul>
							<template v-if="!allAccepted">
								<li>поставьте все галочки (шаг 1)</li>
							</template>
							<template v-if="userid != 0 && this.areas2.length === 0">
								<li>добавьте свои площадки (шаг 2)</li>
							</template>
						</ul>
					</div>
				</template>
				<template v-else>
					<div v-if="hasShowsThisYear">
						<p style="padding:15px; margin-top: 15px; border: 1px solid #999; color: green"><strong>Заявка успешно
							подана</strong></p>
					</div>
					<div v-else>
						<p style="color: red"><strong>Заявка НЕ подана. У ваших площадок должны быть показы в
							{{ getYear(this.thisYearDate1) }} или {{ getYear(this.thisYearDate2) }} году.</strong></p>
					</div>
				</template>
			
			</div>
			
			<Modal
				v-model="isShow"
				:close="closeModal"
			>
				<div class="modal">
					<i @click="closeModal" class="fas fa-times-circle close_button"></i>
					<Area2
						:thisYearDate1="thisYearDate1"
						:this-year-date2="thisYearDate2"
					/>
				
				</div>
			</Modal>
		</div>
		<div v-else>
			<BaseLoader></BaseLoader>
		</div>
	
	</div>
</template>


<style scoped>
.modal {
	display: block;
	width: 80%;
	max-width: 1110px;
	padding: 30px;
	box-sizing: border-box;
	background-color: #fff;
	font-size: 20px;
	margin: 30px auto 30px;
	position: relative;
}

.close_button {
	position: absolute;
	right: 15px;
	top: 10px;
	font-size: 20px;
	cursor: pointer;
}

.modal .columns.is-multiline {
	justify-content: center;
}

.modal .columns.is-multiline .col1 {
	margin-right: 50px;
	margin-bottom: 70px;
}

.button2 {
	display: inline-block;
}

.errors-block {
	color: red;
	border: 1px solid #999;
	border-radius: 10px;
	padding: 25px;
	margin-bottom: 30px;
}

.step_text {
	padding-left: 0.75rem;
	font-weight: bold;
	color: #F69F22;
	font-size: 23px;
}

.mini_button {
	padding: 10px;
	border: 2px solid #000;
	color: #000;
	margin-right: 15px;
	margin-bottom: 15px;
}

.vue-universal-modal {
	z-index: 9999;
}
</style>